export default {
  path: '/workflow-settings',
  name: 'workflow-settings',
  component: () => import(/* webpackChunkName: "workflow-settings" */ './WorkflowSettings'),
  meta: { requiresAuth: true }
}
